import { NumericFormat } from '../dataTable/types';
export var formatNumericField = function (oldValue, value, format) {
    var _a, _b, _c, _d, _e, _f;
    var trimmedValue = value.replace('e', '');
    var newValue = '';
    if (trimmedValue) {
        switch (format) {
            case NumericFormat.DECIMAL:
                newValue = (_b = (_a = parseDecimal(trimmedValue, 12)) !== null && _a !== void 0 ? _a : oldValue) !== null && _b !== void 0 ? _b : '';
                break;
            case NumericFormat.POSITIVE_NUMERIC:
                newValue = (_d = (_c = parsePositiveNumeric(trimmedValue)) !== null && _c !== void 0 ? _c : oldValue) !== null && _d !== void 0 ? _d : '';
                break;
            default:
                newValue = (_f = (_e = parseNumeric(trimmedValue)) !== null && _e !== void 0 ? _e : oldValue) !== null && _f !== void 0 ? _f : '';
                break;
        }
    }
    return newValue;
};
var parseDecimal = function (value, maxDigits) {
    var newValue = removeAllNonDecimalCharacters(value);
    if (newValue === '-') {
        return newValue;
    }
    else {
        var parsedNumber = parseFloat(newValue);
        if (!isNaN(parsedNumber)) {
            return stripToNDigits(newValue, maxDigits);
        }
        else {
            return null;
        }
    }
};
var parseNumeric = function (value) {
    var numericValue = removeAllNonNumericCharacters(value);
    if (numericValue === '-') {
        return numericValue;
    }
    else {
        var parsedValue = parseInt(numericValue, 10);
        if (isNaN(parsedValue)) {
            return null;
        }
        else {
            return String(parsedValue);
        }
    }
};
var parsePositiveNumeric = function (value) {
    var numericValue = parseInt(value.replace(/\D/g, ''), 10);
    var isPositiveNumber = !isNaN(numericValue) && numericValue > 0 && numericValue <= 0x7fffffff;
    return isPositiveNumber ? String(numericValue) : null;
};
var removeAllNonDecimalCharacters = function (value) {
    return value.replace(/,/g, '.')
        .replace(/[^\d.-]/g, '') // first, remove all characters that aren't common
        .replace(/(?!^)-/g, '') // remove negative characters that aren't in beginning
        .replace('.', '%FD%') // replace first occurrence of decimal point with placeholder
        .replace(/\./g, '') // now replace all but first occurrence (refer to above)
        .replace('%FD%', '.');
};
var removeAllNonNumericCharacters = function (value) {
    if (value.startsWith('-')) {
        return value.replace(/[^\d-]/g, '');
    }
    else {
        return value.replace(/\D/g, '');
    }
};
var stripToNDigits = function (value, length) {
    if (value.indexOf('-') > -1) {
        length++;
    }
    if (value.indexOf('.') > -1) {
        length++;
    }
    return value.substring(0, length);
};
//# sourceMappingURL=utils.js.map